import {
  Alert, AlertIcon, AlertTitle, Box,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { animated as a, useTransition } from 'react-spring';

import { ArrowForwardIcon } from '@chakra-ui/icons';
import { ClickOutSide } from '../_index';
import { useForm } from 'react-hook-form';
import { useFormValue } from '../../context';
import { usePlacesAutocomplete } from '../../hooks';

const AddAddress = ({ handleNext }) => {
  const { formStore, setFormStore } = useFormValue();
  const [show, setShow] = useState(true);
  const [selectedPrediction, setSelectedPrediction] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const predictions = usePlacesAutocomplete(searchValue);
  const [isDisabled, setIsDisabled] = useState(true);
  const [alertMessage, setAlertMessage] = useState({
    type: 'info',
    message: 'We need your address to start your offer',
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: formStore,
    reValidateMode: 'onChange',
  });
  // const address = register('address', { required: true });

  useEffect(() => {}, [formStore]);

  const validateAddress = (value) => {
    if (!value) {
      setAlertMessage({
        type: 'warning',
        message: 'Address is required',
      });
    } else {
      setAlertMessage({
        type: 'success',
        message: 'Looking good',
      });
    }
  };

  const handlePredictionSelection = (e, prediction) => {
    e.preventDefault();
    setSelectedPrediction(prediction);
    setValue('address', prediction.description);
    setSearchValue(prediction.description);
  };

  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  useEffect(() => {}, [searchValue]);

  useEffect(() => {
    if (formStore.address) {
      validateAddress(formStore.address);
    }
  }, []);

  useEffect(() => {
    if (alertMessage.type === 'success') {
      setIsDisabled(false);
    }
  }, [alertMessage]);

  useEffect(() => {}, [selectedPrediction]);

  const submitAndNext = (data) => {
    console.log('addre data', data);
    handleNext();
    setFormStore((prev) => {
      return { ...prev, address: data.address };
    });
  };

  return (
    <>
      {transitions(
        (styles, item) => item && (
        <a.div style={{ ...styles, height: '100%' }}>
          <Box height="100%">
            <form onSubmit={handleSubmit(submitAndNext)}>
              <div className="add-address input-container">
                <label htmlFor="address">Address</label>
                <input
                  type="address"
                  id="address"
                  autoComplete="off"
                  defaultValue={formStore.address}
                  placeholder="Enter Address"
                  {...register('address', {
                    required: true,
                    maxLength: 80,
                  })}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    validateAddress(e.target.value);
                  }}
                />
                <Alert
                  opacity="0.7"
                  backgroundColor="transparent"
                  status={alertMessage.type}
                >
                  <AlertIcon />
                  <AlertTitle mr={2}>{alertMessage.message}</AlertTitle>
                </Alert>
                <Box>
                  {predictions.length && !selectedPrediction ? (
                    <Box
                      px={2}
                      py={2}
                      rounded="lg"
                      borderColor="gray.200"
                      border="1px"
                    >
                      {predictions?.map((prediction) => (
                        <Box
                          py={1}
                          key={prediction?.place_id}
                        >
                          <button
                            type="button"
                            onClick={(e) => handlePredictionSelection(e, prediction)}
                            onKeyDown={(e) => handlePredictionSelection(e, prediction)}
                          >
                            {prediction?.structured_formatting?.main_text
                                  || 'Not found'}
                          </button>
                        </Box>
                      ))}
                      <img
                        styles={{ padding: '.5rem' }}
                        src="https://developers.google.com/maps/documentation/images/powered_by_google_on_white.png"
                        alt="Powered by Google"
                      />
                    </Box>
                  ) : (
                    <div />
                  )}
                  {/* <h3>You searched for: {searchValue}</h3>
                    <h3>
                      You selected:{' '}
                      {selectedPrediction?.structured_formatting?.main_text ||
                        'None'}
                    </h3> */}
                </Box>
              </div>

              <Box
                className="btn-one"
                mt={4}
                py={0}
                display="flex"
                alignItems="center"
                disabled={isDisabled}
              >
                <input
                  type="submit"
                  value="Next Step"
                />
                <ArrowForwardIcon />
              </Box>
            </form>
          </Box>
        </a.div>
        ),
      )}
    </>
  );
};

export default AddAddress;
